import React, { useRef } from 'react';
import useWindowMinWidth from '@upgrade/react-components/hooks/useWindowMinWidth';
import useFocusTrap from '@upgrade/react-components/hooks/useFocusTrap';

import { MenuWrapper as StyledMenuWrapper } from './styles';

const MenuWrapper = ({ children, visible }) => {
  const wrapperRef = useRef(null);
  const [isMd] = useWindowMinWidth('md');

  useFocusTrap(wrapperRef, { shouldTrapFocus: !isMd });

  return (
    <StyledMenuWrapper visible={visible} ref={wrapperRef}>
      {children}
    </StyledMenuWrapper>
  );
};

export default MenuWrapper;
